import { Link } from "react-router-dom";
import { ChevronLeft, LayoutDashboard } from "lucide-react";
import { ossSectionTheme } from "../../config/ossSectionThemes";

/**
 * Intestazione sezione OSS: barra flottante (+ toolbar opzionale per ricerca/filtri/tab).
 */
export default function OssSectionPageHeader({
  sectionKey,
  title,
  subtitle,
  headerExtra,
  backTo = "/oss",
  toolbar,
}) {
  const t = ossSectionTheme[sectionKey];
  if (!t) return null;
  const Icon = t.Icon;

  return (
    <div className="oss-header-bar oss-rise relative mb-4 overflow-hidden print:mb-3 print:rounded-xl print:border-slate-200 print:bg-white print:shadow-none">
      <div className="flex items-center gap-2.5 sm:gap-3 min-h-[64px] px-2 sm:px-2.5 py-2">
        <Link
          to={backTo}
          aria-label="Torna indietro"
          className="oss-icon-btn shrink-0 touch-manipulation print:hidden"
        >
          <ChevronLeft className="w-5 h-5" strokeWidth={2} />
        </Link>

        <span className={`oss-icon-chip ${t.accentSoft} print:hidden`} aria-hidden>
          <Icon className={`w-5 h-5 ${t.iconClass}`} strokeWidth={1.9} />
        </span>

        <div className="min-w-0 flex-1">
          <h1
            className={`text-lg sm:text-xl font-bold tracking-tight leading-tight truncate oss-text print:text-slate-900`}
          >
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-0.5 text-sm oss-muted truncate print:text-slate-600">{subtitle}</p>
          ) : null}
          {headerExtra ? (
            <div className="mt-0.5 text-xs oss-muted print:text-slate-600">{headerExtra}</div>
          ) : null}
        </div>

        <Link
          to="/oss"
          aria-label="Torna alla dashboard OSS"
          className="oss-icon-btn oss-icon-btn--outline shrink-0 px-3 text-sm font-medium touch-manipulation print:hidden"
        >
          <LayoutDashboard className="w-4 h-4" aria-hidden />
          <span className="hidden sm:inline">Dashboard</span>
        </Link>
      </div>

      {toolbar ? (
        <div className="border-t px-3 sm:px-4 py-3 print:hidden" style={{ borderColor: "var(--oss-border)" }}>
          {toolbar}
        </div>
      ) : null}
    </div>
  );
}
